import { getTokenFromSessionStorage } from 'Helpers/TokenHelper'
import { isRuleLockedByOtherUsers, isRuleLockedByCurrentUser } from '../../Helpers/DiscountHelper'
import { createRequest, handleErrorCatchLog } from '../../Helpers/GenericHelpers'
import {} from '../../Slices/Settings/ChannelSlice'
import { RuleLock, addLock, setLocks } from '../../Slices/Omnichannel/LockSlice'

export enum TypeOfLock {
  Omnichannel = 'Omnichannel',
  Expenses = 'Expenses',
}

const getLocks =
  () =>
  async (dispatch, getState): Promise<void> => {
    const state = getState()
    const token = getTokenFromSessionStorage()

    if (!state.present.article.serverConfig || !token) return

    try {
      const response = await createRequest(
        '/api/lock/locks/?config=' + state.present.article.serverConfig,
        'POST',
        {},
        token,
      )
      const data = await response.json()
      dispatch(setLocks(data))
    } catch (err) {
      handleErrorCatchLog(err, 'failed on retrieve Locks')
    }
  }

const acquireLock =
  (doLockRequest: boolean, id?: number, typeOfLock: string = TypeOfLock.Omnichannel) =>
  async (dispatch, getState): Promise<boolean> => {
    const state = getState()
    const token = getTokenFromSessionStorage()

    if (!state.present.article.serverConfig || !token) return true

    const entityId = id ? id : state.present.subRule?.subRuleId ?? state.present.seasonRule.ruleId
    const user = state.present.configuration.userValue
    const locks = state.present.locks.locks

    const lock = isRuleLockedByOtherUsers(locks, entityId, typeOfLock, user)

    if (lock) return false

    if (!doLockRequest && isRuleLockedByCurrentUser(locks, entityId, typeOfLock, user)) return true

    try {
      const response = await createRequest(
        `/api/lock/${entityId}/lock/?config=${state.present.article.serverConfig}&typeOfLock=${typeOfLock}`,
        'POST',
        {},
        token,
      )
      if (response.ok && !isRuleLockedByCurrentUser(locks, entityId, typeOfLock, user)) {
        dispatch(addLock({ ruleId: entityId, typeOfLock: typeOfLock, userId: user } as RuleLock))
      }
      return response.ok
    } catch (err) {
      handleErrorCatchLog(err, 'failed on acquiring locks')
      return false
    }
  }

export { getLocks, acquireLock }
